var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import IframeResizer from "iframe-resizer-react";
import { useMediaQuery } from '@mui/material';
import styled from 'styled-components';
import theme from '../../theme';
var hasWebURI = function (url) {
    return url.includes("http");
};
var StyledIframe = styled(IframeResizer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 600px;\n    margin: 5px;\n    border: 0;\n"], ["\n    height: 600px;\n    margin: 5px;\n    border: 0;\n"])));
var OfficePreview = function (props) {
    var isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    var _a = useState(720), docWidth = _a[0], setDocWidth = _a[1];
    var containerRef = useRef(null);
    useEffect(function () {
        if (isMobile && containerRef.current) {
            setDocWidth(Math.min(containerRef.current.offsetWidth || Infinity, 720));
        }
    }, [containerRef.current, isMobile]);
    return (_jsx("div", __assign({ id: "msdoc-renderer", ref: containerRef }, { children: _jsx(StyledIframe, { id: "msdoc-iframe", title: "msdoc-iframe", src: "https://view.officeapps.live.com/op/embed.aspx?src=".concat(hasWebURI(props.url) ? encodeURIComponent(props.url) : "https://".concat(window.location.hostname), "/").concat(props.url), style: { width: docWidth, height: "600px", margin: 0 } }) })));
};
export default OfficePreview;
var templateObject_1;
